var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_843_8672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.57297 5.601L2.43652 0.0270356C2.41787 0.0123546 2.39546 0.00323097 2.37186 0.000712468C2.34826 -0.00180603 2.32443 0.00238272 2.3031 0.0127978C2.28178 0.0232128 2.26382 0.0394318 2.2513 0.0595918C2.23877 0.0797519 2.23219 0.103036 2.2323 0.126769V1.35048C2.2323 1.42805 2.26871 1.50245 2.32887 1.54994L8.0279 5.99993L2.32887 10.4499C2.26713 10.4974 2.2323 10.5718 2.2323 10.6494V11.8731C2.2323 11.9792 2.3542 12.0377 2.43652 11.9728L9.57297 6.39887C9.63362 6.35155 9.68269 6.29103 9.71644 6.2219C9.75019 6.15277 9.76773 6.07686 9.76773 5.99993C9.76773 5.92301 9.75019 5.84709 9.71644 5.77797C9.68269 5.70884 9.63362 5.64832 9.57297 5.601Z",
    fill: "white",
    fillOpacity: 0.65
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_843_8672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.a6ddd1f1d05836b8e7aa5a42cd39da8d.svg";
export { ForwardRef as ReactComponent };